export const footerLinks = {
    'es-es': [
        {
            title: 'Principales destinos',
            items: [
                {
                    href: 'https://www.wingie.es/vuelos/a-madrid/',
                    title: 'Madrid',
                },
                {
                    href: 'https://www.wingie.es/vuelos/a-barcelona/',
                    title: 'Barcelona',
                },
                {
                    href: 'https://www.wingie.es/vuelos/a-tenerife/',
                    title: 'Tenerife',
                },
                {
                    href: 'https://www.wingie.es/vuelos/a-london/',
                    title: 'London',
                },
                {
                    href: 'https://www.wingie.es/vuelos/a-nap-naples/',
                    title: 'Naples',
                },
                {
                    href: 'https://www.wingie.es/vuelos/a-manchester/',
                    title: 'Manchester',
                },
            ],
        },
        {
            title: 'Países populares',
            items: [
                {
                    href: 'https://www.wingie.es/vuelos/at-austria/',
                    title: 'Austria',
                },
                {
                    href: 'https://www.wingie.es/vuelos/be-belgium/',
                    title: 'Bélgica',
                },
                {
                    href: 'https://www.wingie.es/vuelos/fr-france/',
                    title: 'Francia',
                },
                {
                    href: 'https://www.wingie.es/vuelos/de-germany/',
                    title: 'Alemania',
                },
                {
                    href: 'https://www.wingie.es/vuelos/gr-greece/',
                    title: 'Grecia',
                },
                {
                    href: 'https://www.wingie.es/vuelos/it-italy/',
                    title: 'Italia',
                },
            ],
        },
        {
            title: 'Aerolíneas populares',
            items: [
                {
                    href: 'https://www.wingie.es/vuelos/companias-aereas/iberia/',
                    title: 'Iberia',
                },
                {
                    href: 'https://www.wingie.es/vuelos/companias-aereas/air-europa/',
                    title: 'Air Europa',
                },
                {
                    href: 'https://www.wingie.es/vuelos/companias-aereas/vueling-airlines/',
                    title: 'Vueling Airlines',
                },
                {
                    href: 'https://www.wingie.es/vuelos/companias-aereas/iberia-express/',
                    title: 'Iberia Express',
                },
                {
                    href: 'https://www.wingie.es/vuelos/companias-aereas/binter-canarias/',
                    title: 'Binter Canarias',
                },
                {
                    href: 'https://www.wingie.es/vuelos/companias-aereas/volotea/',
                    title: 'Volotea',
                },
            ],
        },
    ],
    'es-en': [
        {
            title: 'Top Destinations',
            items: [
                {
                    href: 'https://www.wingie.es/en/flights/to-madrid/',
                    title: 'Madrid',
                },
                {
                    href: 'https://www.wingie.es/en/flights/to-barcelona/',
                    title: 'Barcelona',
                },
                {
                    href: 'https://www.wingie.es/en/flights/to-tenerife/',
                    title: 'Tenerife',
                },
                {
                    href: 'https://www.wingie.es/en/flights/to-london/',
                    title: 'London',
                },
                {
                    href: 'https://www.wingie.es/en/flights/to-nap-naples/',
                    title: 'Naples',
                },
                {
                    href: 'https://www.wingie.es/en/flights/to-manchester/',
                    title: 'Manchester',
                },
            ],
        },
        {
            title: 'Popular Countries',
            items: [
                {
                    href: 'https://www.wingie.es/en/flights/at-austria/',
                    title: 'Austria',
                },
                {
                    href: 'https://www.wingie.es/en/flights/be-belgium/',
                    title: 'Belgium',
                },
                {
                    href: 'https://www.wingie.es/en/flights/fr-france/',
                    title: 'France',
                },
                {
                    href: 'https://www.wingie.es/en/flights/de-germany/',
                    title: 'Germany',
                },
                {
                    href: 'https://www.wingie.es/en/flights/gr-greece/',
                    title: 'Greece',
                },
                {
                    href: 'https://www.wingie.es/en/flights/it-italy/',
                    title: 'Italy',
                },
            ],
        },
        {
            title: 'Popular Airlines',
            items: [
                {
                    href: 'https://www.wingie.es/en/flights/airlines/iberia/',
                    title: 'Iberia',
                },
                {
                    href: 'https://www.wingie.es/en/flights/airlines/air-europa/',
                    title: 'Air Europa',
                },
                {
                    href: 'https://www.wingie.es/en/flights/airlines/vueling-airlines/',
                    title: 'Vueling Airlines',
                },
                {
                    href: 'https://www.wingie.es/en/flights/airlines/iberia-express/',
                    title: 'Iberia Express',
                },
                {
                    href: 'https://www.wingie.es/en/flights/airlines/binter-canarias/',
                    title: 'Binter Canarias',
                },
                {
                    href: 'https://www.wingie.es/en/flights/airlines/volotea/',
                    title: 'Volotea',
                },
            ],
        },
    ],
    'es-de': [
        {
            title: 'Top-Destinationen',
            items: [
                {
                    href: 'https://www.wingie.es/de/flug/nach-madrid/',
                    title: 'Madrid',
                },
                {
                    href: 'https://www.wingie.es/de/flug/nach-barcelona/',
                    title: 'Barcelona',
                },
                {
                    href: 'https://www.wingie.es/de/flug/nach-teneriffa-insel/',
                    title: 'Teneriffa-Insel',
                },
                {
                    href: 'https://www.wingie.es/de/flug/nach-london/',
                    title: 'London',
                },
                {
                    href: 'https://www.wingie.es/de/flug/nach-neapel/',
                    title: 'Neapel',
                },
                {
                    href: 'https://www.wingie.es/de/flug/nach-manchester/',
                    title: 'Manchester',
                },
            ],
        },
        {
            title: 'Beliebte Länder',
            items: [
                {
                    href: 'https://www.wingie.es/de/flug/at-oesterreich/',
                    title: 'Österreich',
                },
                {
                    href: 'https://www.wingie.es/de/flug/be-belgien/',
                    title: 'Belgien',
                },
                {
                    href: 'https://www.wingie.es/de/flug/fr-frankreich/',
                    title: 'Frankreich',
                },
                {
                    href: 'https://www.wingie.es/de/flug/de-deutschland/',
                    title: 'Deutschland',
                },
                {
                    href: 'https://www.wingie.es/de/flug/gr-griechenland/',
                    title: 'Griechenland',
                },
                {
                    href: 'https://www.wingie.es/de/flug/it-italien/',
                    title: 'Italien',
                },
            ],
        },
        {
            title: 'Beliebte Fluggesellschaften',
            items: [
                {
                    href: 'https://www.wingie.es/de/flug/airlines/iberia/',
                    title: 'Iberia',
                },
                {
                    href: 'https://www.wingie.es/de/flug/airlines/air-europa/',
                    title: 'Air Europa',
                },
                {
                    href: 'https://www.wingie.es/de/flug/airlines/vueling-airlines/',
                    title: 'Vueling Airlines',
                },
                {
                    href: 'https://www.wingie.es/de/flug/airlines/iberia-express/',
                    title: 'Iberia Express',
                },
                {
                    href: 'https://www.wingie.es/de/flug/airlines/binter-canarias/',
                    title: 'Binter Canarias',
                },
                {
                    href: 'https://www.wingie.es/de/flug/airlines/volotea/',
                    title: 'Volotea',
                },
            ],
        },
    ],
    'es-ru': [
        {
            title: 'Популярные направления',
            items: [
                {
                    href: 'https://www.wingie.es/ru/flights/to-madrid/',
                    title: 'Мадрид',
                },
                {
                    href: 'https://www.wingie.es/ru/flights/to-barcelona/',
                    title: 'Барселона',
                },
                {
                    href: 'https://www.wingie.es/ru/flights/to-tenerife/',
                    title: 'Тенерифе',
                },
                {
                    href: 'https://www.wingie.es/ru/flights/to-london/',
                    title: 'Лондон',
                },
                {
                    href: 'https://www.wingie.es/ru/flights/to-nap-naples/',
                    title: 'Неаполь',
                },
                {
                    href: 'https://www.wingie.es/ru/flights/to-manchester/',
                    title: 'Манчестер',
                },
            ],
        },
        {
            title: 'Популярные страны',
            items: [
                {
                    href: 'https://www.wingie.es/ru/flights/at-austria/',
                    title: 'Австрия',
                },
                {
                    href: 'https://www.wingie.es/ru/flights/be-belgium/',
                    title: 'Бельгия',
                },
                {
                    href: 'https://www.wingie.es/ru/flights/fr-france/',
                    title: 'Франция',
                },
                {
                    href: 'https://www.wingie.es/ru/flights/de-germany/',
                    title: 'Германия',
                },
                {
                    href: 'https://www.wingie.es/ru/flights/gr-greece/',
                    title: 'Греция',
                },
                {
                    href: 'https://www.wingie.es/ru/flights/it-italy/',
                    title: 'Италия',
                },
            ],
        },
        {
            title: 'Популярные авиакомпании',
            items: [
                {
                    href: 'https://www.wingie.es/ru/flights/airlines/iberia/',
                    title: 'Iberia',
                },
                {
                    href: 'https://www.wingie.es/ru/flights/airlines/air-europa/',
                    title: 'Air Europa',
                },
                {
                    href: 'https://www.wingie.es/ru/flights/airlines/vueling-airlines/',
                    title: 'Vueling Airlines',
                },
                {
                    href: 'https://www.wingie.es/ru/flights/airlines/iberia-express/',
                    title: 'Iberia Express',
                },
                {
                    href: 'https://www.wingie.es/ru/flights/airlines/binter-canarias/',
                    title: 'Binter Canarias',
                },
                {
                    href: 'https://www.wingie.es/ru/flights/airlines/volotea/',
                    title: 'Volotea',
                },
            ],
        },
    ],
    'es-ar': [
        {
            title: 'أفضل الوجهات',
            items: [
                {
                    href: 'https://www.wingie.es/ar/flights/to-madrid/',
                    title: 'مدريد',
                },
                {
                    href: 'https://www.wingie.es/ar/flights/to-barcelona/',
                    title: 'برشلونة',
                },
                {
                    href: 'https://www.wingie.es/ar/flights/to-tenerife/',
                    title: 'تينيريفي',
                },
                {
                    href: 'https://www.wingie.es/ar/flights/to-london/',
                    title: 'لندن',
                },
                {
                    href: 'https://www.wingie.es/ar/flights/to-nap-naples/',
                    title: 'نابولي',
                },
                {
                    href: 'https://www.wingie.es/ar/flights/to-manchester/',
                    title: 'مانشستر',
                },
            ],
        },
        {
            title: 'أشهر الدول',
            items: [
                {
                    href: 'https://www.wingie.es/ar/flights/at-austria/',
                    title: 'النمسا',
                },
                {
                    href: 'https://www.wingie.es/ar/flights/be-belgium/',
                    title: 'بلجيكا',
                },
                {
                    href: 'https://www.wingie.es/ar/flights/fr-france/',
                    title: 'فرنسا',
                },
                {
                    href: 'https://www.wingie.es/ar/flights/de-germany/',
                    title: 'ألمانيا',
                },
                {
                    href: 'https://www.wingie.es/ar/flights/gr-greece/',
                    title: 'اليونان',
                },
                {
                    href: 'https://www.wingie.es/ar/flights/it-italy/',
                    title: 'إيطاليا',
                },
            ],
        },
        {
            title: 'أشهر الخطوط الجوية',
            items: [
                {
                    href: 'https://www.wingie.es/ar/flights/airlines/iberia/',
                    title: 'ايبيريا',
                },
                {
                    href: 'https://www.wingie.es/ar/flights/airlines/air-europa/',
                    title: 'Air Europa',
                },
                {
                    href: 'https://www.wingie.es/ar/flights/airlines/vueling-airlines/',
                    title: 'Vueling Airlines',
                },
                {
                    href: 'https://www.wingie.es/ar/flights/airlines/iberia-express/',
                    title: 'Iberia Express',
                },
                {
                    href: 'https://www.wingie.es/ar/flights/airlines/binter-canarias/',
                    title: 'Binter Canarias',
                },
                {
                    href: 'https://www.wingie.es/ar/flights/airlines/volotea/',
                    title: 'Volotea',
                },
            ],
        },
    ],
    'es-it': [
        {
            title: 'Destinazioni principali',
            items: [
                {
                    href: 'https://www.wingie.es/it/flights/to-madrid/',
                    title: 'Madrid',
                },
                {
                    href: 'https://www.wingie.es/it/flights/to-barcelona/',
                    title: 'Barcellona',
                },
                {
                    href: 'https://www.wingie.es/it/flights/to-tenerife/',
                    title: 'Tenerife',
                },
                {
                    href: 'https://www.wingie.es/it/flights/to-london/',
                    title: 'Londra',
                },
                {
                    href: 'https://www.wingie.es/it/flights/to-nap-naples/',
                    title: 'Napoli',
                },
                {
                    href: 'https://www.wingie.es/it/flights/to-manchester/',
                    title: 'Manchester',
                },
            ],
        },
        {
            title: 'Paesi popolari',
            items: [
                {
                    href: 'https://www.wingie.es/it/flights/at-austria/',
                    title: 'Austria',
                },
                {
                    href: 'https://www.wingie.es/it/flights/be-belgium/',
                    title: 'Belgio',
                },
                {
                    href: 'https://www.wingie.es/it/flights/fr-france/',
                    title: 'Francia',
                },
                {
                    href: 'https://www.wingie.es/it/flights/de-germany/',
                    title: 'Germania',
                },
                {
                    href: 'https://www.wingie.es/it/flights/gr-greece/',
                    title: 'Grecia',
                },
                {
                    href: 'https://www.wingie.es/it/flights/it-italy/',
                    title: 'Italia',
                },
            ],
        },
        {
            title: 'Compagnie aeree popolari',
            items: [
                {
                    href: 'https://www.wingie.es/it/flights/airlines/iberia/',
                    title: 'Iberia',
                },
                {
                    href: 'https://www.wingie.es/it/flights/airlines/air-europa/',
                    title: 'Air Europa',
                },
                {
                    href: 'https://www.wingie.es/it/flights/airlines/vueling-airlines/',
                    title: 'Vueling Airlines',
                },
                {
                    href: 'https://www.wingie.es/it/flights/airlines/iberia-express/',
                    title: 'Iberia Express',
                },
                {
                    href: 'https://www.wingie.es/it/flights/airlines/binter-canarias/',
                    title: 'Binter Canarias',
                },
                {
                    href: 'https://www.wingie.es/it/flights/airlines/volotea/',
                    title: 'Volotea',
                },
            ],
        },
    ],
    'es-fr': [
        {
            title: 'Principales destinations',
            items: [
                {
                    href: 'https://www.wingie.es/fr/flights/to-madrid/',
                    title: 'Madrid',
                },
                {
                    href: 'https://www.wingie.es/fr/flights/to-barcelona/',
                    title: 'Barcelone',
                },
                {
                    href: 'https://www.wingie.es/fr/flights/to-tenerife/',
                    title: 'Tenerife',
                },
                {
                    href: 'https://www.wingie.es/fr/flights/to-london/',
                    title: 'Londres',
                },
                {
                    href: 'https://www.wingie.es/fr/flights/to-nap-naples/',
                    title: 'Naples',
                },
                {
                    href: 'https://www.wingie.es/fr/flights/to-manchester/',
                    title: 'Manchester',
                },
            ],
        },
        {
            title: 'Pays populaires',
            items: [
                {
                    href: 'https://www.wingie.es/fr/flights/at-austria/',
                    title: 'Autriche',
                },
                {
                    href: 'https://www.wingie.es/fr/flights/be-belgium/',
                    title: 'Belgique',
                },
                {
                    href: 'https://www.wingie.es/fr/flights/fr-france/',
                    title: 'France',
                },
                {
                    href: 'https://www.wingie.es/fr/flights/de-germany/',
                    title: 'Allemagne',
                },
                {
                    href: 'https://www.wingie.es/fr/flights/gr-greece/',
                    title: 'Grèce',
                },
                {
                    href: 'https://www.wingie.es/fr/flights/it-italy/',
                    title: 'Italie',
                },
            ],
        },
        {
            title: 'Compagnies aériennes populaires',
            items: [
                {
                    href: 'https://www.wingie.es/fr/flights/airlines/iberia/',
                    title: 'Iberia',
                },
                {
                    href: 'https://www.wingie.es/fr/flights/airlines/air-europa/',
                    title: 'Air Europa',
                },
                {
                    href: 'https://www.wingie.es/fr/flights/airlines/vueling-airlines/',
                    title: 'Vueling Airlines',
                },
                {
                    href: 'https://www.wingie.es/fr/flights/airlines/iberia-express/',
                    title: 'Iberia Express',
                },
                {
                    href: 'https://www.wingie.es/fr/flights/airlines/binter-canarias/',
                    title: 'Binter Canarias',
                },
                {
                    href: 'https://www.wingie.es/fr/flights/airlines/volotea/',
                    title: 'Volotea',
                },
            ],
        },
    ],
    'es-pt': [
        {
            title: 'Principais destinos',
            items: [
                {
                    href: 'https://www.wingie.es/pt/flights/to-madrid/',
                    title: 'Madrid',
                },
                {
                    href: 'https://www.wingie.es/pt/flights/to-barcelona/',
                    title: 'Barcelona',
                },
                {
                    href: 'https://www.wingie.es/pt/flights/to-tenerife/',
                    title: 'Tenerife',
                },
                {
                    href: 'https://www.wingie.es/pt/flights/to-london/',
                    title: 'Londres',
                },
                {
                    href: 'https://www.wingie.es/pt/flights/to-nap-naples/',
                    title: 'Nápoles',
                },
                {
                    href: 'https://www.wingie.es/pt/flights/to-manchester/',
                    title: 'Manchester',
                },
            ],
        },
        {
            title: 'Países populares',
            items: [
                {
                    href: 'https://www.wingie.es/pt/flights/at-austria/',
                    title: 'Áustria',
                },
                {
                    href: 'https://www.wingie.es/pt/flights/be-belgium/',
                    title: 'Bélgica',
                },
                {
                    href: 'https://www.wingie.es/pt/flights/fr-france/',
                    title: 'França',
                },
                {
                    href: 'https://www.wingie.es/pt/flights/de-germany/',
                    title: 'Alemanha',
                },
                {
                    href: 'https://www.wingie.es/pt/flights/gr-greece/',
                    title: 'Grécia',
                },
                {
                    href: 'https://www.wingie.es/pt/flights/it-italy/',
                    title: 'Itália',
                },
            ],
        },
        {
            title: 'Companhias aéreas populares',
            items: [
                {
                    href: 'https://www.wingie.es/pt/flights/airlines/iberia/',
                    title: 'Iberia',
                },
                {
                    href: 'https://www.wingie.es/pt/flights/airlines/air-europa/',
                    title: 'Air Europa',
                },
                {
                    href: 'https://www.wingie.es/pt/flights/airlines/vueling-airlines/',
                    title: 'Vueling Airlines',
                },
                {
                    href: 'https://www.wingie.es/pt/flights/airlines/iberia-express/',
                    title: 'Iberia Express',
                },
                {
                    href: 'https://www.wingie.es/pt/flights/airlines/binter-canarias/',
                    title: 'Binter Canarias',
                },
                {
                    href: 'https://www.wingie.es/pt/flights/airlines/volotea/',
                    title: 'Volotea',
                },
            ],
        },
    ],
    'es-ro': [
        {
            title: 'Destinații principale',
            items: [
                {
                    href: 'https://www.wingie.es/ro/flights/to-madrid/',
                    title: 'Madrid',
                },
                {
                    href: 'https://www.wingie.es/ro/flights/to-barcelona/',
                    title: 'Barcelona',
                },
                {
                    href: 'https://www.wingie.es/ro/flights/to-tenerife/',
                    title: 'Tenerife',
                },
                {
                    href: 'https://www.wingie.es/ro/flights/to-london/',
                    title: 'Londra',
                },
                {
                    href: 'https://www.wingie.es/ro/flights/to-nap-naples/',
                    title: 'Napoli',
                },
                {
                    href: 'https://www.wingie.es/ro/flights/to-manchester/',
                    title: 'Manchester',
                },
            ],
        },
        {
            title: 'Țări populare',
            items: [
                {
                    href: 'https://www.wingie.es/ro/flights/at-austria/',
                    title: 'Austria',
                },
                {
                    href: 'https://www.wingie.es/ro/flights/be-belgium/',
                    title: 'Belgia',
                },
                {
                    href: 'https://www.wingie.es/ro/flights/fr-france/',
                    title: 'Franța',
                },
                {
                    href: 'https://www.wingie.es/ro/flights/de-germany/',
                    title: 'Germania',
                },
                {
                    href: 'https://www.wingie.es/ro/flights/gr-greece/',
                    title: 'Grecia',
                },
                {
                    href: 'https://www.wingie.es/ro/flights/it-italy/',
                    title: 'Italia',
                },
            ],
        },
        {
            title: 'Companii aeriene populare',
            items: [
                {
                    href: 'https://www.wingie.es/ro/flights/airlines/iberia/',
                    title: 'Iberia',
                },
                {
                    href: 'https://www.wingie.es/ro/flights/airlines/air-europa/',
                    title: 'Air Europa',
                },
                {
                    href: 'https://www.wingie.es/ro/flights/airlines/vueling-airlines/',
                    title: 'Vueling Airlines',
                },
                {
                    href: 'https://www.wingie.es/ro/flights/airlines/iberia-express/',
                    title: 'Iberia Express',
                },
                {
                    href: 'https://www.wingie.es/ro/flights/airlines/binter-canarias/',
                    title: 'Binter Canarias',
                },
                {
                    href: 'https://www.wingie.es/ro/flights/airlines/volotea/',
                    title: 'Volotea',
                },
            ],
        },
    ],
    'es-pl': [
        {
            title: 'Główne kierunki',
            items: [
                {
                    href: 'https://www.wingie.es/pl/flights/to-madrid/',
                    title: 'Madryt',
                },
                {
                    href: 'https://www.wingie.es/pl/flights/to-barcelona/',
                    title: 'Barcelona',
                },
                {
                    href: 'https://www.wingie.es/pl/flights/to-tenerife/',
                    title: 'Teneryfa',
                },
                {
                    href: 'https://www.wingie.es/pl/flights/to-london/',
                    title: 'Londyn',
                },
                {
                    href: 'https://www.wingie.es/pl/flights/to-nap-naples/',
                    title: 'Neapol',
                },
                {
                    href: 'https://www.wingie.es/pl/flights/to-manchester/',
                    title: 'Manchester',
                },
            ],
        },
        {
            title: 'Popularne kraje',
            items: [
                {
                    href: 'https://www.wingie.es/pl/flights/at-austria/',
                    title: 'Austria',
                },
                {
                    href: 'https://www.wingie.es/pl/flights/be-belgium/',
                    title: 'Belgia',
                },
                {
                    href: 'https://www.wingie.es/pl/flights/fr-france/',
                    title: 'Francja',
                },
                {
                    href: 'https://www.wingie.es/pl/flights/de-germany/',
                    title: 'Niemcy',
                },
                {
                    href: 'https://www.wingie.es/pl/flights/gr-greece/',
                    title: 'Grecja',
                },
                {
                    href: 'https://www.wingie.es/pl/flights/it-italy/',
                    title: 'Włochy',
                },
            ],
        },
        {
            title: 'Popularne linie lotnicze',
            items: [
                {
                    href: 'https://www.wingie.es/pl/flights/airlines/iberia/',
                    title: 'Iberia',
                },
                {
                    href: 'https://www.wingie.es/pl/flights/airlines/air-europa/',
                    title: 'Air Europa',
                },
                {
                    href: 'https://www.wingie.es/pl/flights/airlines/vueling-airlines/',
                    title: 'Vueling Airlines',
                },
                {
                    href: 'https://www.wingie.es/pl/flights/airlines/iberia-express/',
                    title: 'Iberia Express',
                },
                {
                    href: 'https://www.wingie.es/pl/flights/airlines/binter-canarias/',
                    title: 'Binter Canarias',
                },
                {
                    href: 'https://www.wingie.es/pl/flights/airlines/volotea/',
                    title: 'Volotea',
                },
            ],
        },
    ],
    'es-lt': [
        {
            title: 'Pagrindinės kryptys',
            items: [
                {
                    href: 'https://www.wingie.es/lt/flights/to-madrid/',
                    title: 'Madridas',
                },
                {
                    href: 'https://www.wingie.es/lt/flights/to-barcelona/',
                    title: 'Barselona',
                },
                {
                    href: 'https://www.wingie.es/lt/flights/to-tenerife/',
                    title: 'Tenerifė',
                },
                {
                    href: 'https://www.wingie.es/lt/flights/to-london/',
                    title: 'Londonas',
                },
                {
                    href: 'https://www.wingie.es/lt/flights/to-nap-naples/',
                    title: 'Neapolis',
                },
                {
                    href: 'https://www.wingie.es/lt/flights/to-manchester/',
                    title: 'Mančesteris',
                },
            ],
        },
        {
            title: 'Populiarios šalys',
            items: [
                {
                    href: 'https://www.wingie.es/lt/flights/at-austria/',
                    title: 'Austrija',
                },
                {
                    href: 'https://www.wingie.es/lt/flights/be-belgium/',
                    title: 'Belgija',
                },
                {
                    href: 'https://www.wingie.es/lt/flights/fr-france/',
                    title: 'Prancūzija',
                },
                {
                    href: 'https://www.wingie.es/lt/flights/de-germany/',
                    title: 'Vokietija',
                },
                {
                    href: 'https://www.wingie.es/lt/flights/gr-greece/',
                    title: 'Graikija',
                },
                {
                    href: 'https://www.wingie.es/lt/flights/it-italy/',
                    title: 'Italija',
                },
            ],
        },
        {
            title: 'Populiarūs oro linijų bendrovės',
            items: [
                {
                    href: 'https://www.wingie.es/lt/flights/airlines/iberia/',
                    title: 'Iberia',
                },
                {
                    href: 'https://www.wingie.es/lt/flights/airlines/air-europa/',
                    title: 'Air Europa',
                },
                {
                    href: 'https://www.wingie.es/lt/flights/airlines/vueling-airlines/',
                    title: 'Vueling Airlines',
                },
                {
                    href: 'https://www.wingie.es/lt/flights/airlines/iberia-express/',
                    title: 'Iberia Express',
                },
                {
                    href: 'https://www.wingie.es/lt/flights/airlines/binter-canarias/',
                    title: 'Binter Canarias',
                },
                {
                    href: 'https://www.wingie.es/lt/flights/airlines/volotea/',
                    title: 'Volotea',
                },
            ],
        },
    ],
    'es-uz': [
        {
            title: "Asosiy yo'nalishlar",
            items: [
                { href: 'https://www.wingie.es/uz/flights/to-madrid/', title: 'Madrid' },
                { href: 'https://www.wingie.es/uz/flights/to-barcelona/', title: 'Barselona' },
                { href: 'https://www.wingie.es/uz/flights/to-tenerife/', title: 'Tenerife' },
                { href: 'https://www.wingie.es/uz/flights/to-london/', title: 'London' },
                { href: 'https://www.wingie.es/uz/flights/to-nap-naples/', title: 'Neapol' },
                { href: 'https://www.wingie.es/uz/flights/to-manchester/', title: 'Manchester' },
            ],
        },
        {
            title: 'Mashhur mamlakatlar',
            items: [
                { href: 'https://www.wingie.es/uz/flights/at-austria/', title: 'Avstriya' },
                { href: 'https://www.wingie.es/uz/flights/be-belgium/', title: 'Belgiya' },
                { href: 'https://www.wingie.es/uz/flights/fr-france/', title: 'Fransiya' },
                { href: 'https://www.wingie.es/uz/flights/de-germany/', title: 'Germaniya' },
                { href: 'https://www.wingie.es/uz/flights/gr-greece/', title: 'Gretsiya' },
                { href: 'https://www.wingie.es/uz/flights/it-italy/', title: 'Italiya' },
            ],
        },
        {
            title: 'Mashhur aviakompaniyalar',
            items: [
                { href: 'https://www.wingie.es/uz/flights/airlines/iberia/', title: 'Iberia' },
                { href: 'https://www.wingie.es/uz/flights/airlines/air-europa/', title: 'Air Europa' },
                { href: 'https://www.wingie.es/uz/flights/airlines/vueling-airlines/', title: 'Vueling Airlines' },
                { href: 'https://www.wingie.es/uz/flights/airlines/iberia-express/', title: 'Iberia Express' },
                { href: 'https://www.wingie.es/uz/flights/airlines/binter-canarias/', title: 'Binter Canarias' },
                { href: 'https://www.wingie.es/uz/flights/airlines/volotea/', title: 'Volotea' },
            ],
        },
    ],
    'es-sr': [
        {
            title: 'Главни правци',
            items: [
                { href: 'https://www.wingie.es/sr/flights/to-madrid/', title: 'Мадрид' },
                { href: 'https://www.wingie.es/sr/flights/to-barcelona/', title: 'Барселона' },
                { href: 'https://www.wingie.es/sr/flights/to-tenerife/', title: 'Тенерифе' },
                { href: 'https://www.wingie.es/sr/flights/to-london/', title: 'Лондон' },
                { href: 'https://www.wingie.es/sr/flights/to-nap-naples/', title: 'Напуљ' },
                { href: 'https://www.wingie.es/sr/flights/to-manchester/', title: 'Манчестер' },
            ],
        },
        {
            title: 'Популарне земље',
            items: [
                { href: 'https://www.wingie.es/sr/flights/at-austria/', title: 'Аустрија' },
                { href: 'https://www.wingie.es/sr/flights/be-belgium/', title: 'Белгија' },
                { href: 'https://www.wingie.es/sr/flights/fr-france/', title: 'Француска' },
                { href: 'https://www.wingie.es/sr/flights/de-germany/', title: 'Немачка' },
                { href: 'https://www.wingie.es/sr/flights/gr-greece/', title: 'Грчка' },
                { href: 'https://www.wingie.es/sr/flights/it-italy/', title: 'Италија' },
            ],
        },
        {
            title: 'Популарне авио-компаније',
            items: [
                { href: 'https://www.wingie.es/sr/flights/airlines/iberia/', title: 'Iberia' },
                { href: 'https://www.wingie.es/sr/flights/airlines/air-europa/', title: 'Air Europa' },
                { href: 'https://www.wingie.es/sr/flights/airlines/vueling-airlines/', title: 'Vueling Airlines' },
                { href: 'https://www.wingie.es/sr/flights/airlines/iberia-express/', title: 'Iberia Express' },
                { href: 'https://www.wingie.es/sr/flights/airlines/binter-canarias/', title: 'Binter Canarias' },
                { href: 'https://www.wingie.es/sr/flights/airlines/volotea/', title: 'Volotea' },
            ],
        },
    ],
    'es-ky': [
        {
            title: 'Негизги багыттар',
            items: [
                { href: 'https://www.wingie.es/ky/flights/to-madrid/', title: 'Мадрид' },
                { href: 'https://www.wingie.es/ky/flights/to-barcelona/', title: 'Барселона' },
                { href: 'https://www.wingie.es/ky/flights/to-tenerife/', title: 'Тенерифе' },
                { href: 'https://www.wingie.es/ky/flights/to-london/', title: 'Лондон' },
                { href: 'https://www.wingie.es/ky/flights/to-nap-naples/', title: 'Неаполь' },
                { href: 'https://www.wingie.es/ky/flights/to-manchester/', title: 'Манчестер' },
            ],
        },
        {
            title: 'Популярдуу өлкөлөр',
            items: [
                { href: 'https://www.wingie.es/ky/flights/at-austria/', title: 'Австрия' },
                { href: 'https://www.wingie.es/ky/flights/be-belgium/', title: 'Бельгия' },
                { href: 'https://www.wingie.es/ky/flights/fr-france/', title: 'Франция' },
                { href: 'https://www.wingie.es/ky/flights/de-germany/', title: 'Германия' },
                { href: 'https://www.wingie.es/ky/flights/gr-greece/', title: 'Греция' },
                { href: 'https://www.wingie.es/ky/flights/it-italy/', title: 'Италия' },
            ],
        },
        {
            title: 'Популярдуу авиакомпаниялар',
            items: [
                { href: 'https://www.wingie.es/ky/flights/airlines/iberia/', title: 'Iberia' },
                { href: 'https://www.wingie.es/ky/flights/airlines/air-europa/', title: 'Air Europa' },
                { href: 'https://www.wingie.es/ky/flights/airlines/vueling-airlines/', title: 'Vueling Airlines' },
                { href: 'https://www.wingie.es/ky/flights/airlines/iberia-express/', title: 'Iberia Express' },
                { href: 'https://www.wingie.es/ky/flights/airlines/binter-canarias/', title: 'Binter Canarias' },
                { href: 'https://www.wingie.es/ky/flights/airlines/volotea/', title: 'Volotea' },
            ],
        },
    ],
    'es-tg': [
        {
            title: 'Самтҳои асосӣ',
            items: [
                { href: 'https://www.wingie.es/tg/flights/to-madrid/', title: 'Мадрид' },
                { href: 'https://www.wingie.es/tg/flights/to-barcelona/', title: 'Барселона' },
                { href: 'https://www.wingie.es/tg/flights/to-tenerife/', title: 'Тенерифе' },
                { href: 'https://www.wingie.es/tg/flights/to-london/', title: 'Лондон' },
                { href: 'https://www.wingie.es/tg/flights/to-nap-naples/', title: 'Неапол' },
                { href: 'https://www.wingie.es/tg/flights/to-manchester/', title: 'Манчестер' },
            ],
        },
        {
            title: 'Кишварҳои машҳур',
            items: [
                { href: 'https://www.wingie.es/tg/flights/at-austria/', title: 'Австрия' },
                { href: 'https://www.wingie.es/tg/flights/be-belgium/', title: 'Белгия' },
                { href: 'https://www.wingie.es/tg/flights/fr-france/', title: 'Фаронса' },
                { href: 'https://www.wingie.es/tg/flights/de-germany/', title: 'Олмон' },
                { href: 'https://www.wingie.es/tg/flights/gr-greece/', title: 'Юнон' },
                { href: 'https://www.wingie.es/tg/flights/it-italy/', title: 'Итолия' },
            ],
        },
        {
            title: 'Авиакомпанияҳои машҳур',
            items: [
                { href: 'https://www.wingie.es/tg/flights/airlines/iberia/', title: 'Iberia' },
                { href: 'https://www.wingie.es/tg/flights/airlines/air-europa/', title: 'Air Europa' },
                { href: 'https://www.wingie.es/tg/flights/airlines/vueling-airlines/', title: 'Vueling Airlines' },
                { href: 'https://www.wingie.es/tg/flights/airlines/iberia-express/', title: 'Iberia Express' },
                { href: 'https://www.wingie.es/tg/flights/airlines/binter-canarias/', title: 'Binter Canarias' },
                { href: 'https://www.wingie.es/tg/flights/airlines/volotea/', title: 'Volotea' },
            ],
        },
    ],
    'es-kk': [
        {
            title: 'Негізгі бағыттар',
            items: [
                { href: 'https://www.wingie.es/kk/flights/to-madrid/', title: 'Мадрид' },
                { href: 'https://www.wingie.es/kk/flights/to-barcelona/', title: 'Барселона' },
                { href: 'https://www.wingie.es/kk/flights/to-tenerife/', title: 'Тенерифе' },
                { href: 'https://www.wingie.es/kk/flights/to-london/', title: 'Лондон' },
                { href: 'https://www.wingie.es/kk/flights/to-nap-naples/', title: 'Неаполь' },
                { href: 'https://www.wingie.es/kk/flights/to-manchester/', title: 'Манчестер' },
            ],
        },
        {
            title: 'Танымал елдер',
            items: [
                { href: 'https://www.wingie.es/kk/flights/at-austria/', title: 'Австрия' },
                { href: 'https://www.wingie.es/kk/flights/be-belgium/', title: 'Бельгия' },
                { href: 'https://www.wingie.es/kk/flights/fr-france/', title: 'Франция' },
                { href: 'https://www.wingie.es/kk/flights/de-germany/', title: 'Германия' },
                { href: 'https://www.wingie.es/kk/flights/gr-greece/', title: 'Греция' },
                { href: 'https://www.wingie.es/kk/flights/it-italy/', title: 'Италия' },
            ],
        },
        {
            title: 'Танымал авиакомпаниялар',
            items: [
                { href: 'https://www.wingie.es/kk/flights/airlines/iberia/', title: 'Iberia' },
                { href: 'https://www.wingie.es/kk/flights/airlines/air-europa/', title: 'Air Europa' },
                { href: 'https://www.wingie.es/kk/flights/airlines/vueling-airlines/', title: 'Vueling Airlines' },
                { href: 'https://www.wingie.es/kk/flights/airlines/iberia-express/', title: 'Iberia Express' },
                { href: 'https://www.wingie.es/kk/flights/airlines/binter-canarias/', title: 'Binter Canarias' },
                { href: 'https://www.wingie.es/kk/flights/airlines/volotea/', title: 'Volotea' },
            ],
        },
    ],
    'es-nl': [
        {
            title: 'Populaire bestemmingen',
            items: [
                { href: 'https://www.wingie.es/nl/flights/to-madrid/', title: 'Madrid' },
                { href: 'https://www.wingie.es/nl/flights/to-barcelona/', title: 'Barcelona' },
                { href: 'https://www.wingie.es/nl/flights/to-tenerife/', title: 'Tenerife' },
                { href: 'https://www.wingie.es/nl/flights/to-london/', title: 'Londen' },
                { href: 'https://www.wingie.es/nl/flights/to-nap-naples/', title: 'Napels' },
                { href: 'https://www.wingie.es/nl/flights/to-manchester/', title: 'Manchester' },
            ],
        },
        {
            title: 'Populaire landen',
            items: [
                { href: 'https://www.wingie.es/nl/flights/at-austria/', title: 'Oostenrijk' },
                { href: 'https://www.wingie.es/nl/flights/be-belgium/', title: 'België' },
                { href: 'https://www.wingie.es/nl/flights/fr-france/', title: 'Frankrijk' },
                { href: 'https://www.wingie.es/nl/flights/de-germany/', title: 'Duitsland' },
                { href: 'https://www.wingie.es/nl/flights/gr-greece/', title: 'Griekenland' },
                { href: 'https://www.wingie.es/nl/flights/it-italy/', title: 'Italië' },
            ],
        },
        {
            title: 'Populaire luchtvaartmaatschappijen',
            items: [
                { href: 'https://www.wingie.es/nl/flights/airlines/iberia/', title: 'Iberia' },
                { href: 'https://www.wingie.es/nl/flights/airlines/air-europa/', title: 'Air Europa' },
                { href: 'https://www.wingie.es/nl/flights/airlines/vueling-airlines/', title: 'Vueling Airlines' },
                { href: 'https://www.wingie.es/nl/flights/airlines/iberia-express/', title: 'Iberia Express' },
                { href: 'https://www.wingie.es/nl/flights/airlines/binter-canarias/', title: 'Binter Canarias' },
                { href: 'https://www.wingie.es/nl/flights/airlines/volotea/', title: 'Volotea' },
            ],
        },
    ],
    'es-ja': [
        {
            title: '人気の目的地',
            items: [
                { title: 'ラスベガス', href: 'https://www.wingie.es/ja/flights/to-las-vegas/' },
                { title: 'シカゴ', href: 'https://www.wingie.es/ja/flights/to-chicago/' },
                { title: 'マイアミ', href: 'https://www.wingie.es/ja/flights/to-miami/' },
                { title: 'カンクン', href: 'https://www.wingie.es/ja/flights/to-cancun/' },
                { title: 'ロンドン', href: 'https://www.wingie.es/ja/flights/to-london/' },
                { title: 'ホノルル', href: 'https://www.wingie.es/ja/flights/to-honolulu/' },
            ],
        },
        {
            title: '人気の国',
            items: [
                { title: 'カナダ', href: 'https://www.wingie.es/ja/flights/ca-canada/' },
                { title: '中国', href: 'https://www.wingie.es/ja/flights/cn-china/' },
                { title: 'コスタリカ', href: 'https://www.wingie.es/ja/flights/cr-costa-rica/' },
                { title: 'ドミニカ共和国', href: 'https://www.wingie.es/ja/flights/do-dominican-republic/' },
                { title: 'エルサルバドル', href: 'https://www.wingie.es/ja/flights/sv-el-salvador/' },
                { title: 'フランス', href: 'https://www.wingie.es/ja/flights/fr-france/' },
            ],
        },
        {
            title: '人気の航空会社',
            items: [
                { title: 'アメリカン・エアラインズ', href: 'https://www.wingie.es/ja/flights/airlines/american-airlines/' },
                { title: 'デルタ航空', href: 'https://www.wingie.es/ja/flights/airlines/delta-air-lines/' },
                { title: 'ユナイテッド航空', href: 'https://www.wingie.es/ja/flights/airlines/united-airlines/' },
                { title: 'アラスカ航空', href: 'https://www.wingie.es/ja/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.es/ja/flights/airlines/jetblue/' },
                { title: 'ハワイアン航空', href: 'https://www.wingie.es/ja/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'es-zh': [
        {
            title: '热门目的地',
            items: [
                { title: '拉斯维加斯', href: 'https://www.wingie.es/zh/flights/to-las-vegas/' },
                { title: '芝加哥', href: 'https://www.wingie.es/zh/flights/to-chicago/' },
                { title: '迈阿密', href: 'https://www.wingie.es/zh/flights/to-miami/' },
                { title: '坎昆', href: 'https://www.wingie.es/zh/flights/to-cancun/' },
                { title: '伦敦', href: 'https://www.wingie.es/zh/flights/to-london/' },
                { title: '火奴鲁鲁', href: 'https://www.wingie.es/zh/flights/to-honolulu/' },
            ],
        },
        {
            title: '热门国家',
            items: [
                { title: '加拿大', href: 'https://www.wingie.es/zh/flights/ca-canada/' },
                { title: '中国', href: 'https://www.wingie.es/zh/flights/cn-china/' },
                { title: '哥斯达黎加', href: 'https://www.wingie.es/zh/flights/cr-costa-rica/' },
                { title: '多米尼加共和国', href: 'https://www.wingie.es/zh/flights/do-dominican-republic/' },
                { title: '萨尔瓦多', href: 'https://www.wingie.es/zh/flights/sv-el-salvador/' },
                { title: '法国', href: 'https://www.wingie.es/zh/flights/fr-france/' },
            ],
        },
        {
            title: '热门航空公司',
            items: [
                { title: '美国航空', href: 'https://www.wingie.es/zh/flights/airlines/american-airlines/' },
                { title: '达美航空', href: 'https://www.wingie.es/zh/flights/airlines/delta-air-lines/' },
                { title: '美联航', href: 'https://www.wingie.es/zh/flights/airlines/united-airlines/' },
                { title: '阿拉斯加航空', href: 'https://www.wingie.es/zh/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.es/zh/flights/airlines/jetblue/' },
                { title: '夏威夷航空', href: 'https://www.wingie.es/zh/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'es-ko': [
        {
            title: '인기 목적지',
            items: [
                { title: '라스베이거스', href: 'https://www.wingie.es/ko/flights/to-las-vegas/' },
                { title: '시카고', href: 'https://www.wingie.es/ko/flights/to-chicago/' },
                { title: '마이애미', href: 'https://www.wingie.es/ko/flights/to-miami/' },
                { title: '칸쿤', href: 'https://www.wingie.es/ko/flights/to-cancun/' },
                { title: '런던', href: 'https://www.wingie.es/ko/flights/to-london/' },
                { title: '호놀룰루', href: 'https://www.wingie.es/ko/flights/to-honolulu/' },
            ],
        },
        {
            title: '인기 국가',
            items: [
                { title: '캐나다', href: 'https://www.wingie.es/ko/flights/ca-canada/' },
                { title: '중국', href: 'https://www.wingie.es/ko/flights/cn-china/' },
                { title: '코스타리카', href: 'https://www.wingie.es/ko/flights/cr-costa-rica/' },
                { title: '도미니카 공화국', href: 'https://www.wingie.es/ko/flights/do-dominican-republic/' },
                { title: '엘살바도르', href: 'https://www.wingie.es/ko/flights/sv-el-salvador/' },
                { title: '프랑스', href: 'https://www.wingie.es/ko/flights/fr-france/' },
            ],
        },
        {
            title: '인기 항공사',
            items: [
                { title: '아메리칸 항공', href: 'https://www.wingie.es/ko/flights/airlines/american-airlines/' },
                { title: '델타 항공', href: 'https://www.wingie.es/ko/flights/airlines/delta-air-lines/' },
                { title: '유나이티드 항공', href: 'https://www.wingie.es/ko/flights/airlines/united-airlines/' },
                { title: '알래스카 항공', href: 'https://www.wingie.es/ko/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.es/ko/flights/airlines/jetblue/' },
                { title: '하와이안 항공', href: 'https://www.wingie.es/ko/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'es-hi': [
        {
            title: 'लोकप्रिय गंतव्य',
            items: [
                { title: 'लास वेगास', href: 'https://www.wingie.es/hi/flights/to-las-vegas/' },
                { title: 'शिकागो', href: 'https://www.wingie.es/hi/flights/to-chicago/' },
                { title: 'मियामी', href: 'https://www.wingie.es/hi/flights/to-miami/' },
                { title: 'कैनकन', href: 'https://www.wingie.es/hi/flights/to-cancun/' },
                { title: 'लंदन', href: 'https://www.wingie.es/hi/flights/to-london/' },
                { title: 'होनोलुलु', href: 'https://www.wingie.es/hi/flights/to-honolulu/' },
            ],
        },
        {
            title: 'लोकप्रिय देश',
            items: [
                { title: 'कनाडा', href: 'https://www.wingie.es/hi/flights/ca-canada/' },
                { title: 'चीन', href: 'https://www.wingie.es/hi/flights/cn-china/' },
                { title: 'कोस्टा रिका', href: 'https://www.wingie.es/hi/flights/cr-costa-rica/' },
                { title: 'डोमिनिकन गणराज्य', href: 'https://www.wingie.es/hi/flights/do-dominican-republic/' },
                { title: 'अल सल्वाडोर', href: 'https://www.wingie.es/hi/flights/sv-el-salvador/' },
                { title: 'फ्रांस', href: 'https://www.wingie.es/hi/flights/fr-france/' },
            ],
        },
        {
            title: 'लोकप्रिय एयरलाइनें',
            items: [
                { title: 'अमेरिकन एयरलाइन्स', href: 'https://www.wingie.es/hi/flights/airlines/american-airlines/' },
                { title: 'डेल्टा एयरलाइन्स', href: 'https://www.wingie.es/hi/flights/airlines/delta-air-lines/' },
                { title: 'यूनाइटेड एयरलाइन्स', href: 'https://www.wingie.es/hi/flights/airlines/united-airlines/' },
                { title: 'अलास्का एयरलाइन्स', href: 'https://www.wingie.es/hi/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.es/hi/flights/airlines/jetblue/' },
                { title: 'हवाई एयरलाइन्स', href: 'https://www.wingie.es/hi/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'es-ta': [
        {
            title: 'பிரபலமான இலக்குகள்',
            items: [
                { title: 'லாஸ் வெகாஸ்', href: 'https://www.wingie.es/ta/flights/to-las-vegas/' },
                { title: 'சிகாகோ', href: 'https://www.wingie.es/ta/flights/to-chicago/' },
                { title: 'மியாமி', href: 'https://www.wingie.es/ta/flights/to-miami/' },
                { title: 'கான்கன்', href: 'https://www.wingie.es/ta/flights/to-cancun/' },
                { title: 'லண்டன்', href: 'https://www.wingie.es/ta/flights/to-london/' },
                { title: 'ஓனோலுலு', href: 'https://www.wingie.es/ta/flights/to-honolulu/' },
            ],
        },
        {
            title: 'பிரபலமான நாடுகள்',
            items: [
                { title: 'கனடா', href: 'https://www.wingie.es/ta/flights/ca-canada/' },
                { title: 'சீனா', href: 'https://www.wingie.es/ta/flights/cn-china/' },
                { title: 'கோஸ்டா ரிக்கா', href: 'https://www.wingie.es/ta/flights/cr-costa-rica/' },
                { title: 'டொமினிக்கன் குடியரசு', href: 'https://www.wingie.es/ta/flights/do-dominican-republic/' },
                { title: 'எல் சால்வடோர்', href: 'https://www.wingie.es/ta/flights/sv-el-salvador/' },
                { title: 'பிரான்சு', href: 'https://www.wingie.es/ta/flights/fr-france/' },
            ],
        },
        {
            title: 'பிரபலமான விமான நிறுவனங்கள்',
            items: [
                { title: 'அமெரிக்கன் ஏர்லைன்ஸ்', href: 'https://www.wingie.es/ta/flights/airlines/american-airlines/' },
                { title: 'டெல்டா ஏர்லைன்ஸ்', href: 'https://www.wingie.es/ta/flights/airlines/delta-air-lines/' },
                { title: 'யுனைட்டட் ஏர்லைன்ஸ்', href: 'https://www.wingie.es/ta/flights/airlines/united-airlines/' },
                { title: 'அலாஸ்கா ஏர்லைன்ஸ்', href: 'https://www.wingie.es/ta/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.es/ta/flights/airlines/jetblue/' },
                { title: 'ஹவாய் ஏர்லைன்ஸ்', href: 'https://www.wingie.es/ta/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'es-th': [
        {
            title: 'จุดหมายยอดนิยม',
            items: [
                { title: 'ลาสเวกัส', href: 'https://www.wingie.es/th/flights/to-las-vegas/' },
                { title: 'ชิคาโก', href: 'https://www.wingie.es/th/flights/to-chicago/' },
                { title: 'ไมอามี', href: 'https://www.wingie.es/th/flights/to-miami/' },
                { title: 'แคนคูน', href: 'https://www.wingie.es/th/flights/to-cancun/' },
                { title: 'ลอนดอน', href: 'https://www.wingie.es/th/flights/to-london/' },
                { title: 'โฮโนลูลู', href: 'https://www.wingie.es/th/flights/to-honolulu/' },
            ],
        },
        {
            title: 'ประเทศยอดนิยม',
            items: [
                { title: 'แคนาดา', href: 'https://www.wingie.es/th/flights/ca-canada/' },
                { title: 'จีน', href: 'https://www.wingie.es/th/flights/cn-china/' },
                { title: 'คอสตาริกา', href: 'https://www.wingie.es/th/flights/cr-costa-rica/' },
                { title: 'สาธารณรัฐโดมินิกัน', href: 'https://www.wingie.es/th/flights/do-dominican-republic/' },
                { title: 'เอลซัลวาดอร์', href: 'https://www.wingie.es/th/flights/sv-el-salvador/' },
                { title: 'ฝรั่งเศส', href: 'https://www.wingie.es/th/flights/fr-france/' },
            ],
        },
        {
            title: 'สายการบินยอดนิยม',
            items: [
                { title: 'อเมริกันแอร์ไลน์', href: 'https://www.wingie.es/th/flights/airlines/american-airlines/' },
                { title: 'เดลต้า แอร์ไลน์', href: 'https://www.wingie.es/th/flights/airlines/delta-air-lines/' },
                { title: 'ยูไนเต็ด แอร์ไลน์', href: 'https://www.wingie.es/th/flights/airlines/united-airlines/' },
                { title: 'อลาสก้าแอร์ไลน์', href: 'https://www.wingie.es/th/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.es/th/flights/airlines/jetblue/' },
                { title: 'ฮาวายแอนแอร์ไลน์', href: 'https://www.wingie.es/th/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'es-ur': [
        {
            title: 'مشہور منزلیں',
            items: [
                { title: 'لاس ویگاس', href: 'https://www.wingie.es/ur/flights/to-las-vegas/' },
                { title: 'شکاگو', href: 'https://www.wingie.es/ur/flights/to-chicago/' },
                { title: 'میامی', href: 'https://www.wingie.es/ur/flights/to-miami/' },
                { title: 'کینکن', href: 'https://www.wingie.es/ur/flights/to-cancun/' },
                { title: 'لندن', href: 'https://www.wingie.es/ur/flights/to-london/' },
                { title: 'ہونولولو', href: 'https://www.wingie.es/ur/flights/to-honolulu/' },
            ],
        },
        {
            title: 'مشہور ممالک',
            items: [
                { title: 'کینیڈا', href: 'https://www.wingie.es/ur/flights/ca-canada/' },
                { title: 'چین', href: 'https://www.wingie.es/ur/flights/cn-china/' },
                { title: 'کوسٹا ریکا', href: 'https://www.wingie.es/ur/flights/cr-costa-rica/' },
                { title: 'ڈومینیکن جمہوریہ', href: 'https://www.wingie.es/ur/flights/do-dominican-republic/' },
                { title: 'ایل سیلواڈور', href: 'https://www.wingie.es/ur/flights/sv-el-salvador/' },
                { title: 'فرانس', href: 'https://www.wingie.es/ur/flights/fr-france/' },
            ],
        },
        {
            title: 'مشہور ایئر لائنز',
            items: [
                { title: 'امریکن ایئرلائنز', href: 'https://www.wingie.es/ur/flights/airlines/american-airlines/' },
                { title: 'ڈیلٹا ایئر لائنز', href: 'https://www.wingie.es/ur/flights/airlines/delta-air-lines/' },
                { title: 'یونائیٹڈ ایئرلائنز', href: 'https://www.wingie.es/ur/flights/airlines/united-airlines/' },
                { title: 'الاسکا ایئرلائنز', href: 'https://www.wingie.es/ur/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.es/ur/flights/airlines/jetblue/' },
                { title: 'ہوائی ایئرلائنز', href: 'https://www.wingie.es/ur/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'es-ka': [
        {
            title: 'პოპულარული მიმართულებები',
            items: [
                { title: 'ლას-ვეგასი', href: 'https://www.wingie.es/ka/flights/to-las-vegas/' },
                { title: 'ჩიკაგო', href: 'https://www.wingie.es/ka/flights/to-chicago/' },
                { title: 'მაიამი', href: 'https://www.wingie.es/ka/flights/to-miami/' },
                { title: 'კანკუნი', href: 'https://www.wingie.es/ka/flights/to-cancun/' },
                { title: 'ლონდონი', href: 'https://www.wingie.es/ka/flights/to-london/' },
                { title: 'ჰონოლულუ', href: 'https://www.wingie.es/ka/flights/to-honolulu/' },
            ],
        },
        {
            title: 'პოპულარული ქვეყნები',
            items: [
                { title: 'კანადა', href: 'https://www.wingie.es/ka/flights/ca-canada/' },
                { title: 'ჩინეთი', href: 'https://www.wingie.es/ka/flights/cn-china/' },
                { title: 'კოსტა-რიკა', href: 'https://www.wingie.es/ka/flights/cr-costa-rica/' },
                { title: 'დომინიკელთა რესპუბლიკა', href: 'https://www.wingie.es/ka/flights/do-dominican-republic/' },
                { title: 'სალვადორი', href: 'https://www.wingie.es/ka/flights/sv-el-salvador/' },
                { title: 'საფრანგეთი', href: 'https://www.wingie.es/ka/flights/fr-france/' },
            ],
        },
        {
            title: 'პოპულარული ავიაკომპანიები',
            items: [
                { title: 'ამერიკის ავიაკომპანია', href: 'https://www.wingie.es/ka/flights/airlines/american-airlines/' },
                { title: 'დელტა ეარ ლაინზი', href: 'https://www.wingie.es/ka/flights/airlines/delta-air-lines/' },
                { title: 'იუნაიტედ ერლაინზი', href: 'https://www.wingie.es/ka/flights/airlines/united-airlines/' },
                { title: 'ალასკას ავიაკომპანია', href: 'https://www.wingie.es/ka/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.es/ka/flights/airlines/jetblue/' },
                { title: 'ჰავაუს ავიაკომპანია', href: 'https://www.wingie.es/ka/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ]
}